<template>
  <textarea
    ref="proaInputTextarea"
    v-if="textareaMode"
    :class="{ 'dark': dark }"
    :placeholder="placeholder"
    :value="value"
    @input="adjustHeight(); $emit('input', $event.target.value)"
    spellcheck="false"
    :rows="rows"
  />
  <input
    v-else
    :class="{ 'dark': dark, 'invalid': invalid }"
    :type="type"
    :placeholder="placeholder"
    :value="value"
    @input="$emit('input', $event.target.value)"
  />
</template>

<script>
export default {
  name: 'ProaInput',
  props: {
    dark: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    rows: {
      type: [String, Number],
      default: 10
    },
    type: String,
    placeholder: String,
    value: String
  },
  computed: {
    textareaMode: function() { return this.type === 'textarea' }
  },
  methods: {
    adjustHeight: function() {
      const textarea = this.$refs.proaInputTextarea
      textarea.style.height = 'auto'
      textarea.style.height = textarea.scrollHeight + 'px'
    },
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

input, textarea {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  background-color: white;
  background-clip: padding-box;
  border: 1px solid $light-border-color;

  &.invalid {
    border-color: $error-color;
  }

  &:focus {
    outline: none;
  }
}

textarea {
  resize: none;
  overflow: hidden;
  padding: 20px;
}

.dark {
  background-color: $light-gray-color;
  border: 1px solid $dark-border-color;
}
</style>
